import { render, staticRenderFns } from "./layout-header.vue?vue&type=template&id=1cd939b8"
import script from "./layout-header.vue?vue&type=script&lang=js"
export * from "./layout-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports